import { render, staticRenderFns } from "./monthlyTaskDetail.vue?vue&type=template&id=905937b6&scoped=true"
import script from "./monthlyTaskDetail.vue?vue&type=script&lang=js"
export * from "./monthlyTaskDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905937b6",
  null
  
)

export default component.exports